import { IStyleFunctionOrObject } from "@fluentui/react";
import { HomeStyleProps, HomeStyles } from "./Home.types";

export const getStyles: IStyleFunctionOrObject<HomeStyleProps, HomeStyles> = (
  props: HomeStyleProps
) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { theme } = props;
  return {
    root: {},
  };
};
